module.exports = __webpack_public_path__ + "img/HeroWithVideoBackground.a4bd4412.png";